import { useEffect } from "react";
import { useQuery } from "react-query";
import { api } from "services/api";
import { SupportShift } from "types/SupportAgent";
import { handleRequestError } from "utils/Request";

async function fetchSupportShifts(shiftDate: string): Promise<SupportShift[]> {
  const { data } = await api.get('/support/shifts', { params: { shift_date: shiftDate } });
  return data;
}

export function useSupportShifts(shiftDate: string) {
  const query = useQuery(['support-shifts', shiftDate], () => fetchSupportShifts(shiftDate), {
    enabled: !!shiftDate,
  });

  useEffect(() => {
    if (!query.isError) return;
    handleRequestError(query.error, 'Erro ao listar plantão. Tente novamente.');
  }, [query.isError, query.error]);

  return query;
}
